export enum Role {
  NuminarAdmin = 'NuminarAdmin',
  ManagedOutreachCoordinator = 'ManagedOutreachCoordinator',
  DTAdmin = 'DTAdmin',
  Owner = 'Owner',
  OrgAdmin = 'Admin',
  ParentAdmin = 'ParentAdmin',
  Staff = 'Staff',
  FieldOrganizer = 'FieldOrganizer',
  Volunteer = 'Volunteer',
  Supporter = 'Supporter',
  DatatrustOwner = 'DatatrustOwner',
  DatatrustUser = 'DatatrustUser',
}

export function isRole(role: string): role is Role {
  return Object.values(Role).includes(role as Role);
}

export function isDTRole(userRole: Role | string): boolean {
  return [Role.DTAdmin, Role.DatatrustOwner, Role.DatatrustUser].includes(userRole as Role);
}

export function isNuminarRole(userRole: Role | string): boolean {
  return [
    Role.NuminarAdmin,
    Role.ManagedOutreachCoordinator,
    Role.Owner,
    Role.OrgAdmin,
    Role.ParentAdmin,
    Role.Staff,
    Role.FieldOrganizer,
    Role.Volunteer,
    Role.Supporter,
  ].includes(userRole as Role);
}
